import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import print from "../../static/print.png";
import logoAnaDerme from "../../static/logo-ana-derme.png";
import logoBec from "../../static/logo-bec.jpg";
import logoSds from "../../static/logo-sds.png";
import "./Portfolio.scss";

function Portfolio() {
    let slidesPerView = 2;
    let spaceBetween = 40;

    if (window.innerWidth < 768) {
        slidesPerView = 1;
        spaceBetween = 20;
    }

    return (
        <section className="portfolio" id="portfolio">
            <div className="container">
                <div className="portfolio__wrapper">
                    <h3 className="title"><span>Portfólio</span>Empresas que confiam</h3>

                    <Swiper 
                        className="portfolio__wrapper__cards"
                        modules={[Navigation, Pagination]}
                        spaceBetween={spaceBetween} 
                        navigation 
                        pagination={{ clickable: true }} 
                        slidesPerView={slidesPerView}
                    >
                        <SwiperSlide>
                            <div className="portfolio__wrapper__cards__card">
                                <div className="portfolio__wrapper__cards__card__user">
                                    <div className="portfolio__wrapper__cards__card__user__image">
                                        <img src={logoAnaDerme} alt="Logo Ana Derme" />
                                    </div>
                                    <div className="portfolio__wrapper__cards__card__user__name">
                                        <a href="https://www.anaderme.com.br" target="_blank" rel="noopener noreferrer">Ana Derme</a>
                                        <span>Farmácia de manipulação</span>
                                    </div>
                                </div>

                                <div className="portfolio__wrapper__cards__card__feedback">
                                    <p>A Encode Bytes transformou completamente nossa presença digital. A nova versão do nosso site trouxe mais credibilidade para a marca e aumentou significativamente o número de clientes. Hoje conseguimos transmitir profissionalismo e confiança desde o primeiro contato.</p>
                                </div>

                                {/* <div className="portfolio__wrapper__cards__card__print">
                                    <img src={print} alt="Imagem do site do cliente" />
                                </div> */}
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="portfolio__wrapper__cards__card">
                                <div className="portfolio__wrapper__cards__card__user">
                                    <div className="portfolio__wrapper__cards__card__user__image">
                                        <img src={logoBec} alt="Logo BEC Editora" />
                                    </div>
                                    <div className="portfolio__wrapper__cards__card__user__name">
                                        <a>BEC Editora</a>
                                        <span>Editora</span>
                                    </div>
                                </div>

                                <div className="portfolio__wrapper__cards__card__feedback">
                                    <p>A Encode Bytes me auxiliou na melhoria e na evolução do nosso site, trazendo mais harmonia, confiança e credibilidade à apresentação dos nossos produtos e da nossa marca. Hoje, temos uma parceria forte e importante, com suporte e auxílio completos desde o início.</p>
                                </div>

                                {/* <div className="portfolio__wrapper__cards__card__print">
                                    <img src={print} alt="Imagem do site do cliente" />
                                </div> */}
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default Portfolio;